import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetUser } from '../../Hooks/user/user.get.hooks';
import PropTypes from 'prop-types';
import FormLoading from '../../Components/LoadingPages/LoadingForm.component';
// FOR EDITING USER DATA
const EditUserDataProvider = ({ userId, children }) => {
  const {
    data: userInfo,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['userInfo', userId],
    queryFn: () => httpGetUser(userId),
    enabled: !!userId,
    retry: 5,
  });

  if (isLoading) return <FormLoading />;
  if (isError) return <p>Error loading user data</p>;
  // console.log('User Info:', userInfo);

  return children(userInfo);
};
EditUserDataProvider.propTypes = {
  userId: PropTypes.string,
  children: PropTypes.func,
};

export default EditUserDataProvider;
